import {UnlinkLinkedInAccountUserCommand} from '@perfectpost/perfect-post-common';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {sessionKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Dissocie le compte LinkedIn.
 *
 * Remplace le thunk `unlinkLinkedin` de `src/store/mainslice.ts`, dont le reducer
 * recopiait la réponse dans `state.main.user`.
 */
export function useUnlinkLinkedinMutation(options: MutationUiOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: [...sessionKeys.mutations(), 'unlinkLinkedin'],
    mutationFn: () => sendOrThrow(new UnlinkLinkedInAccountUserCommand()),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: sessionKeys.me()});
    },
  });
}
